import styled from "styled-components";

export const StyledWrapper = styled.div`
  div {
    margin: 0 12px 24px;
    padding: 24px;
    color: ${({ theme }) => theme.colors.neutralsText};
    ${({ theme }) => theme.fontStyles.DesktopLargeBodyCopy}
    text-align: center;
    background-color: ${({ theme }) => theme.colors.neutralsWhite};
    border-left: 6px solid ${({ theme }) => theme.colors.offTrackBackground};
    border-radius: 4px;
  }
`;
